import React, { useState } from 'react'
import Modal from 'components/Modal/Modal'
import { Button, Form } from 'react-bootstrap'
import ReactLoading from 'react-loader-spinner'
import { ReactComponent as PictoDownload } from 'assets/default/svg/picto_download.svg'
import useExportFavoris from 'hooks/useExportFavoris'
import IconSelector from 'components/Form/Helpers/IconSelector/IconSelector'
import pushToDataLayer from 'utils/pushToDataLayer'
import cn from 'classnames'
import s from './ExportFavoris.module.scss'

interface Props {
  className?: string
  disabled?: boolean
  children: React.ReactNode
}

const defaultProps = {
  className: undefined,
  disabled: false,
}

const ExportFavoris = ({
  className,
  disabled,
  children,
}: Props): JSX.Element => {
  const {
    show,
    loading,
    error,
    showModal,
    exportSelectionToPdf,
    exportSelectionToEmail,
    cancelExport,
  } = useExportFavoris()
  const [choice, setChoice] = useState<'' | 'send' | 'download'>('')
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (choice === 'send') exportSelectionToEmail()
    if (choice === 'download') exportSelectionToPdf()
  }

  return (
    <>
      <Button
        className={cn('btn-export-favoris', className)}
        onClick={showModal}
        disabled={disabled}
      >
        {children}
      </Button>
      <Modal
        additionalModalClassNames={s.modal}
        show={show}
        title="Exporter des favoris"
        onCloseButtonClick={cancelExport}
        body={
          <>
            <Form className={s.form} onSubmit={handleSubmit}>
              <h2 className={s.title}>
                Comment souhaitez-vous exporter les favoris ?
              </h2>
              <IconSelector
                onChange={(value) => setChoice(value as 'send' | 'download')}
                value={choice}
                options={[
                  {
                    icon: <PictoDownload />,
                    label: 'Télécharger',
                    value: 'download',
                  },
                ]}
              />
              <div className={s.controls}>
                <Button
                  className={cn(s.btn, s.cancel)}
                  variant="outline-primary"
                  onClick={cancelExport}
                >
                  Annuler
                </Button>
                <Button
                  className={cn(s.btn, s.confirm)}
                  type="submit"
                  onClick={() => {
                    pushToDataLayer({
                      event: 'exportFavoris',
                    })
                  }}
                >
                  {loading ? (
                    <ReactLoading type="Oval" color="#fff" height="2.4rem" />
                  ) : (
                    'Continuer'
                  )}
                </Button>
              </div>
            </Form>
            {error && <p className="text-danger text-center">{error}</p>}
          </>
        }
      />
    </>
  )
}

ExportFavoris.defaultProps = defaultProps
export default ExportFavoris
